export default __webpack_public_path__ + "static/media/DIABETE_ICONA1.5c13ad0d.svg";